import { render, staticRenderFns } from "./In_Policy.vue?vue&type=template&id=370a5b46&"
import script from "./In_Policy.vue?vue&type=script&lang=js&"
export * from "./In_Policy.vue?vue&type=script&lang=js&"
import style0 from "./In_Policy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanels})
